import React from 'react';
import { CheckCircle, XCircle, AlertTriangle } from 'lucide-react';

interface PrinterStatusBadgeProps {
    status: 'available' | 'unavailable' | 'error';
    className?: string;
}

export const PrinterStatusBadge: React.FC<PrinterStatusBadgeProps> = ({ status, className = '' }) => {
    const statusConfig = {
        available: {
            icon: CheckCircle,
            text: 'Disponible',
            bgColor: 'bg-green-100',
            textColor: 'text-green-800',
            iconColor: 'text-green-600',
        },
        unavailable: {
            icon: XCircle,
            text: 'Sin agentes',
            bgColor: 'bg-red-100',
            textColor: 'text-red-800',
            iconColor: 'text-red-600',
        },
        error: {
            icon: AlertTriangle,
            text: 'Error',
            bgColor: 'bg-yellow-100',
            textColor: 'text-yellow-800',
            iconColor: 'text-yellow-600',
        },
    };

    const config = statusConfig[status];
    const Icon = config.icon;

    return (
        <span
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold ${config.bgColor} ${config.textColor} ${className}`}
            title={`Estado: ${config.text}`}
        >
            <Icon size={14} className={config.iconColor} />
            {config.text}
        </span>
    );
};
